import axios from "axios";
import Store from "@/store";

let ACCESS_TOKEN = Store.state.auth.accessToken;
let TENANT_ID = Store.state.auth.tenantId;
/**
 *  The client which is an axios instance
 * @param baseUrl
 * @param additionalHeaders
 * @param useTenant
 * @returns {AxiosInstance}
 */
let client = (baseUrl = null, additionalHeaders = {}, useTenant = true) => {
  let accessToken = ACCESS_TOKEN;
  let tenantId = TENANT_ID;

  if (ACCESS_TOKEN == null) {
    accessToken = "";
  }

  let defaultHeaders = {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (accessToken.length > 0) {
    defaultHeaders["Authorization"] = "Bearer " + accessToken;
  }
  if (tenantId && useTenant) {
    defaultHeaders["X-Tenant"] = Store.state.auth.tenantId;
  }

  let axiosOptions = {
    baseURL: baseUrl,
    headers: {
      ...defaultHeaders,
      ...additionalHeaders,
    },
  };

  return axios.create(axiosOptions);
};

/**
 * Class that creates APIs
 */
class ApiClientFactory {
  /**
   * Set the baseUrl
   * @param {string} baseUrl
   * @param {boolean} useTenant
   * @param {boolean} forceBase
   */
  constructor(baseUrl = process.env.VUE_APP_TENANT_API_URL, useTenant = true, forceBase = false) {
    this.baseUrl = Store.getters["tenant/isCentral"] && !forceBase ? process.env.VUE_APP_CENTRAL_API_URL : baseUrl;
    this.useTenant = Store.getters["tenant/isCentral"] ? false : useTenant;
  }

  /**
   * Perform a get request
   * @param {string} url
   * @param {Object} [requestData={}]
   * @param {Object} [headers={}]
   * @returns {Promise<AxiosResponse<any>>}
   */
  get(url, requestData = {}, headers = {}) {
    return client(this.baseUrl, headers, this.useTenant).get(url, requestData);
  }

  /**
   * Perform a post request
   * @param {string} url
   * @param {Object} [requestData={}]
   * @param {Object} [headers={}]
   * @returns {Promise<AxiosResponse<any>>}
   */
  post(url, requestData = {}, headers = {}) {
    return client(this.baseUrl, headers, this.useTenant).post(url, requestData);
  }

  /**
   * Perform a put request
   * @param {string} url
   * @param {Object} [requestData={}] The Request dadta
   * @param {Object} [headers={}]
   * @returns {Promise<AxiosResponse<any>>}
   */
  put(url, requestData = {}, headers = {}) {
    return client(this.baseUrl, headers, this.useTenant).put(url, requestData);
  }

  /**
   * Perform a delete request
   * @param {string} url
   * @param {Object} [requestData={}]
   * @param {Object} [headers={}]
   * @returns {Promise<AxiosResponse<any>>}
   */
  delete(url, requestData = {}, headers = {}) {
    return client(this.baseUrl, headers, this.useTenant).delete(url, requestData);
  }
}

export { ApiClientFactory };
